import getAuthHost from './getAuthHost'
import * as type from '@/utvStore/store/mutation-types'

const authServer = getAuthHost()
const axiosInstance = axios.create({
  timeout: 800000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  }
})

export default {
  getProfile(access_token, store = null) {
    let errors = {}
    if (!access_token) {
      errors.message = 'アクセストークンがありません。'
      return Promise.reject(errors)
    }
    return axiosInstance
      .post(`${authServer}/api/user/info`, {
        access_token
      })
      .then(res => {
        if (res.data.response === 'NG') {
          Object.assign(res, {
            message: 'データの取得に失敗しました。'
          })
          return Promise.reject(res.data)
        }
        // nickname, emailはres.data.user直下のため整形
        const profile = res.data.user.profile
        Object.assign(profile, {
          response: res.data.response,
          nickname: res.data.user.nickname,
          email: res.data.user.email
        })
        store.commit(type.GET_USER_INFO, res.data.user)
        store.commit(type.GET_ACCOUNT, profile)
        store.commit(type.GET_SUBSCRIPTION_INFO, res.data.user.subscription)
        return Promise.resolve(profile)
      })
      .catch(error => {
        throw new Error(error) //これどっちか削るべきか
        return Promise.reject(error)
      })
  },
  /**
   * accountサーバー上のユーザー情報を更新する
   * @param {Object} data - 更新するユーザー情報 - https://docs.google.com/spreadsheets/d/1vrbGZxhAhEczKfT9kCjPR3S8EpDsoMn7TVRDE1voRlQ/edit?pli=1#gid=888101574
   * @return {Promise}
   */
  updateProfile(data) {
    return axiosInstance
      .post(`${authServer}/api/user/info/update`, data)
      .then(
        res => {
          if (res.data.response === 'OK') {
            return Promise.resolve(res.data)
          } else {
            return Promise.reject(res.data)
          }
        },
        error => {
          error = pushErrorMessage(error)
          return Promise.reject(error)
        }
      )
      .catch(error => {
        throw new Error(error)
        return Promise.reject(error)
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/fetchAccountData.js